import React from "react";
import { CheckCircle, XCircle } from "lucide-react";

// Active / Inactive pill for an is_activated column.
export default function ActiveBadge({ active }) {
  return active ? (
    <span className="inline-flex items-center gap-1.5 rounded-md border border-success_border bg-success_bg px-2 py-0.5 text-[11px] font-medium text-success">
      <CheckCircle size={12} /> Active
    </span>
  ) : (
    <span className="inline-flex items-center gap-1.5 rounded-md border border-border bg-surface_alt px-2 py-0.5 text-[11px] font-medium text-text_secondary">
      <XCircle size={12} /> Inactive
    </span>
  );
}
